import ajaxClient from "../../../../js/common/AjaxClient";

export interface FilterKeyValuePair {
    readonly id: number;
    readonly title: string;
    readonly quantity?: number;
}

export default new class ProductListAutocompleteService {
    private packageProducersCache: Record<string, FilterKeyValuePair[]> = {};
    private bookAuthorsCache: Record<string, FilterKeyValuePair[]> = {};

    public async getPackageProducerFilterValues(term: string): Promise<FilterKeyValuePair[]> {
        if (term in this.packageProducersCache) {
            return this.packageProducersCache[term];
        }

        try {
            const response = await ajaxClient.get<FilterKeyValuePair[]>("/Category/jsAutocompletePackageProducers", {
                params: {
                    term: term,
                },
            });

            this.packageProducersCache[term] = response;

            return response;
        } catch {
            return [];
        }
    }

    public async getBookAuthorFilterValues(term: string): Promise<FilterKeyValuePair[]> {
        if (term in this.bookAuthorsCache) {
            return this.bookAuthorsCache[term];
        }

        try {
            const response = await ajaxClient.get<FilterKeyValuePair[]>("/Category/jsAutocompleteAuthors", {
                params: {
                    term: term,
                },
            });

            this.bookAuthorsCache[term] = response;

            return response;
        } catch {
            return [];
        }
    }
}();
